import styled from "styled-components";

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns}, minmax(0, 1fr));
  gap: ${props => props.$gap}px;
`;

export const StyledColumn = styled.div`
  position: relative;
  height: ${props => props.$height}px;
  overflow: visible;
`;

export const StyledVirtualItem = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: translateY(${props => props.$translateY}px);
  overflow: visible;
`;

export const StyledSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.$gap}px;
`;
